import ListDomainsStep from './ListDomainsStep'
import DnsStep from './DnsStep'
import EmailStep from './EmailStep'

export const stepComponents = {
  LIST_DOMAINS: ListDomainsStep,
  DNS_DETAILS: DnsStep,
  EMAIL_SENT: EmailStep
}
